// Helper utilities for adding/removing small diagnostic overlay layers (fills/lines/points)
// Keep types broad to be compatible with the MapFacade map wrappers used across the app.

import { Map } from "maplibre-gl";
import { MapFacadeMaplibre } from "src/managers/MapFacadeMaplibre";

export function removeLayer(map: any, id: string) {
  try {
    if (!map) return;
    if (map.getLayer && map.getLayer(id + '-fill')) map.removeLayer(id + '-fill');
    if (map.getLayer && map.getLayer(id + '-outline')) map.removeLayer(id + '-outline');
    if (map.getLayer && map.getLayer(id + '-point')) map.removeLayer(id + '-point');
    if (map.getSource && map.getSource(id)) map.removeSource(id);
  } catch (e) {
    // swallowing minor map errors here - callers can log if needed
    console.debug('removeLayer helper error', e);
  }
}

function ensureSource(map: any, id: string) {
  if (!map) return;
  if (!map.getSource || !map.addSource) return;
  if (!map.getSource(id)) {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
  }
}

export function addConflictLayer(map: Map, id: string) {
  const color = "#ffdd1a"
  map.addSource(id, {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] }
  });
  map.addLayer({
    id: id + "-fill",
    type: 'fill',
    source: id,
    paint: {
      'fill-color': color,
      'fill-opacity': 0.4
    },
    "filter": ['==', '$type', 'Polygon']
  });
  map.addLayer({
    id: id + "-outline",
    type: 'line',
    source: id,
    paint: {
      'line-color': color,
      'line-width': 2
    },
  });
  map.addLayer({
    id: id + "-linestring",
    type: 'line',
    source: id,
    paint: {
      'line-color': 'red',
      'line-width': 2,
      'line-dasharray': [2, 2]
    }
  })
  map.addLayer({
    id: id + "-point",
    type: 'symbol',
    source: id,
    layout: {
      'icon-image': 'mit-pin-' + color,
      'icon-anchor': 'bottom',
      'icon-size': 1,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true
    },
    filter: ['==', '$type', 'Point']
  });
}

export function removeConflictLayer(map: Map, id: string) {
  map.removeLayer(id + "-fill");
  map.removeLayer(id + "-outline");
  map.removeLayer(id + "-point");
  map.removeLayer(id + "-linestring");
  map.removeSource(id);
}
export function addConflictDisplayLayer(map: Map, id: string) {
  const color = "blue"
  map.addSource(id, {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] }
  });
  map.addLayer({
    id: id + "-fill",
    type: 'fill',
    source: id,
    paint: {
      'fill-color': color,
      'fill-opacity': 0.4
    },
    "filter": ['==', '$type', 'Polygon']
  });
  map.addLayer({
    id: id + "-outline",
    type: 'line',
    source: id,
    paint: {
      'line-color': color,
      'line-width': 2
    },
  });
  map.addLayer({
    id: id + "-point",
    type: 'symbol',
    source: id,
    layout: {
      'icon-image': 'mit-pin-' + color,
      'icon-anchor': 'bottom',
      'icon-size': 1,
      'icon-allow-overlap': true,
      'icon-ignore-placement': true
    },
    filter: ['==', '$type', 'Point']
  });
}

export function removeDisplayLayer(map: Map, id: string) {
  map.removeLayer(id + "-fill");
  map.removeLayer(id + "-outline");
  map.removeLayer(id + "-point");
  map.removeLayer(id + "-linestring");
  map.removeSource(id);
}